import { useEffect, useState } from "react";
import { useHistory } from "react-router";

const usePathListener = () => {
  const [pathname, setPathname] = useState("");
  const history = useHistory();

  useEffect(() => {
    setPathname(location.pathname);

    const unregisterHistoryListener = history.listen((location) => {
      setPathname(location.pathname);
    });
    return () => unregisterHistoryListener();
  }, []);

  return {
    pathname,
  };
};

export default usePathListener;
